import { render, staticRenderFns } from "./P007.vue?vue&type=template&id=20d5a044"
import script from "./P007.vue?vue&type=script&lang=js"
export * from "./P007.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports